import { createAction } from '@reduxjs/toolkit'
import { LineMeasurement } from '../models/Measurement'

export const addLineMeasurement = createAction<
  Partial<Pick<LineMeasurement, 'id'>> &
    Pick<LineMeasurement, 'startPoint' | 'endPoint' | 'isVisible'>
>('measurement/addLineMeasurement')

export const updateLineMeasurement = createAction<{
  id: string
  data: Partial<Pick<LineMeasurement, 'startPoint' | 'endPoint' | 'isVisible'>>
}>('measurement/updateLineMeasurement')

export const removeLineMeasurement = createAction<{
  id: string
}>('measurement/removeLineMeasurement')
